<template>
	<v-toolbar color="white" elevation="2" class="toolbar-custom">
		<div class="logo-container">
			<v-img 
				src="/img/logo_ubga.jpg" 
				height="45px" 
				max-width="55px" 
				contain 
				class="logo-img"
			/>
			<v-img 
				src="/img/logotipo-600x100.png" 
				height="45px" 
				max-width="120px" 
				contain 
				class="logo-img ml-2"
			/>
		</div>

		<v-spacer></v-spacer>

		<div class="actions-container">
			<v-tooltip bottom color="black">
				<template v-slot:activator="{ on, attrs }">
					<v-btn 
						icon 
						@click="home"
						v-bind="attrs"
						v-on="on"
						class="action-btn"
					>
						<v-icon>mdi-home</v-icon>
					</v-btn>
				</template>
				<span>Inicio</span>
			</v-tooltip>

			<v-tooltip bottom color="black" v-if="isAdmin">
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						@click="adminMenu"
						v-bind="attrs"
						v-on="on"
						class="action-btn"
					>
						<v-icon>mdi-tools</v-icon>
					</v-btn>
				</template>
				<span>Administración</span>
			</v-tooltip>

			<v-tooltip bottom color="black" v-if="mostrarVista(12)">
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						@click="config"
						v-bind="attrs"
						v-on="on"
						class="action-btn"
					>
						<v-icon>mdi-cog</v-icon>
					</v-btn>
				</template>
				<span>Configuración</span>
			</v-tooltip>

			<NetworkCheck class="mx-1" />

			<UsersOnline v-if="mostrarVista(5)" class="mx-1" />

			<v-tooltip bottom color="black">
				<template v-slot:activator="{ on, attrs }">
					<v-btn 
						icon 
						@click="logout"
						v-bind="attrs"
						v-on="on"
						color="error"
						class="action-btn"
					>
						<v-icon>mdi-power</v-icon>
					</v-btn>
				</template>
				<span>Cerrar sesión</span>
			</v-tooltip>
		</div>
	</v-toolbar>
</template>

<script>
	import axios from "axios"; // 1. Importar Axios
	import { mapGetters, mapState } from "vuex";
	import NetworkCheck from './NetworkCheck.vue';
	import UsersOnline from './UsersOnline.vue';

	export default {
		components: {
			NetworkCheck,
			UsersOnline,
		},
		data: () => ({
			responsive: false,
			responsiveInput: false,
			heartbeatInterval: null // 2. Variable para controlar el intervalo
		}),

		computed: {
			...mapGetters(["authorized"]),
			...mapState(['ids_vistas', 'es_admin']),
			isAdmin(){
				return this.es_admin;
			}
		},

		watch: {
			$route(val) {
				this.title = val.meta.name;
			}
		},

		mounted() {
			this.onResponsiveInverted();
			window.addEventListener("resize", this.onResponsiveInverted);
			
			// 3. Iniciar el Heartbeat al cargar el componente
			this.startHeartbeat();
		},
		beforeDestroy() {
			window.removeEventListener("resize", this.onResponsiveInverted);
			
			// 4. Limpiar el intervalo al destruir el componente para evitar procesos huerfanos
			if (this.heartbeatInterval) {
				clearInterval(this.heartbeatInterval);
			}
		},

		methods: {
			// --- Nuevos Métodos de Heartbeat ---
			startHeartbeat() {
				// Ejecutamos una vez al inicio
				this.checkHeartbeat();
				
				// Configuramos para que se ejecute cada 1 minuto (60,000 ms)
				// Puedes ajustar el tiempo según necesites
				this.heartbeatInterval = setInterval(() => {
					this.checkHeartbeat();
				}, 60000);
			},

			async checkHeartbeat() {
				try {
					// Asumiendo que Axios ya tiene configurado el baseURL. 
					// Si no, usa la URL completa: 'http://api.tusitio.com/Configuraciones/Heartbeat'
					await axios.get('Configuraciones/Heartbeat');
					console.log('Heartbeat: Sesión activa');
				} catch (error) {
					console.error('Heartbeat: Error de conexión o sesión expirada', error);
					
					// Opcional: Si el error es 401 (Unauthorized), cerrar sesión automáticamente
					if (error.response && error.response.status === 401) {
						this.logout();
					}
				}
			},
			// ----------------------------------

			onClickBtn() {
				this.setDrawer(!this.$store.state.app.drawer);
			},
			onResponsiveInverted() {
				if (window.innerWidth < 991) {
					this.responsive = true;
					this.responsiveInput = false;
				} else {
					this.responsive = false;
					this.responsiveInput = true;
				}
			},
			home() {
				this.$router.push("/").catch(() => {});
			},
			config() {
				this.$router.push("/dashboard/configuracion").catch(() => {});
			},
			logout() {
				// Limpiar el intervalo al cerrar sesión
				if (this.heartbeatInterval) clearInterval(this.heartbeatInterval);

				this.$store.dispatch("logout").then(() => {
					this.$router.push("/").catch(() => {});
				});
			},
			mostrarVista(id_vista) {
				if(this.ids_vistas == null || this.ids_vistas.length == 0) return false;
				return (this.ids_vistas.indexOf(id_vista) >= 0);
			},
			verTodasNotificaciones() {
				console.log('all');
			},
			adminMenu(){
				this.$router.push("/dashboard/administracion").catch(() => {});
			}
		}
	};
</script>

<style scoped>
	.toolbar-custom {
		padding: 0 16px;
		border-bottom: 1px solid #e0e0e0;
	}

	.logo-container {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 8px 0;
	}

	.logo-img {
		transition: transform 0.2s ease;
	}

	.logo-img:hover {
		transform: scale(1.05);
	}

	.actions-container {
		display: flex;
		align-items: center;
		gap: 4px;
	}

	.action-btn {
		transition: all 0.2s ease;
	}

	.action-btn:hover {
		background-color: rgba(0, 0, 0, 0.04);
		transform: translateY(-2px);
	}

	/* Responsive */
	@media (max-width: 600px) {
		.toolbar-custom {
			padding: 0 8px;
		}

		.logo-container {
			gap: 4px;
		}

		.actions-container {
			gap: 2px;
		}

		.logo-img {
			max-width: 45px !important;
			height: 35px !important;
		}
	}
</style>